import type { SxProps, Theme } from '@mui/material/styles';

export const rootStyles = {
  flexGrow: 1,
  justifyContent: 'center',
} satisfies SxProps<Theme>;

export const tabsContainerStyles = {
  mb: 4,
  ml: 4,
} satisfies SxProps<Theme>;

export const tabsContainerMobileStyles = {
  ml: 0,
  mr: 0,
  mb: 2,
  pl: 2,
  pr: 2,
} satisfies SxProps<Theme>;
